import { createTheme } from '@00start/ui';

// TransitSafe theme — sky-blue palette aligned with migration 0021's
// tenant row (primary_color = #0ea5e9, accent_color = #0284c7).
// Named `transitSafeTheme` to match the tenant slug, not the peril.
export const transitSafeTheme = createTheme({
  primary: { from: '#0ea5e9', to: '#0284c7' },
  brandName: 'TRANSITSAFE',
  brandSubtext: 'AVIATION COMPLIANCE',
});
